import React from 'react';
import { TextField, InputAdornment, IconButton } from '@mui/material';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

/**
 * Standard search input: search icon, clear button, rounded pill styling.
 */
const SearchField = ({ value, onChange, onClear, placeholder = 'Search…', sx, ...rest }) => (
  <TextField
    fullWidth
    value={value}
    onChange={onChange}
    placeholder={placeholder}
    inputProps={{ 'aria-label': placeholder, ...rest.inputProps }}
    InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <SearchRoundedIcon sx={{ color: 'text.disabled' }} fontSize="small" />
        </InputAdornment>
      ),
      endAdornment: value ? (
        <InputAdornment position="end">
          <IconButton
            size="small"
            aria-label="Clear search"
            onClick={() => (onClear ? onClear() : onChange?.({ target: { value: '' } }))}
          >
            <CloseRoundedIcon fontSize="small" />
          </IconButton>
        </InputAdornment>
      ) : null,
      ...rest.InputProps,
    }}
    sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' }, ...sx }}
    {...rest}
  />
);

export default SearchField;
